import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-multichat-server',
  templateUrl: './multichat-server.component.html',
  styleUrls: ['./multichat-server.component.scss']
})
export class MultichatServerComponent implements OnInit {

  public servers: any[] = [];
  public loading: boolean = false;
  public purchasing: boolean = false;

  constructor(private http: HttpService) {}

  ngOnInit(): void {
    this.loadServers();
  }

  async loadServers() {
    this.loading = true;
    const rtn: any = await this.http.post('/admin/multichat-server/list');
    this.servers = rtn?.servers || [];
    this.loading = false;
  }

  async purchaseServer() {
    if (!confirm('Purchase 1x MultiChat Server @ RM 200.00?\n\nThis will provision a dedicated server for your chat channels.')) return;
    this.purchasing = true;
    const rtn: any = await this.http.post('/admin/multichat-server/purchase');
    this.purchasing = false;
    if (rtn?.status) {
      this.http.notify(rtn.message || 'Server purchased');
      await this.loadServers();
    } else {
      this.http.notify(rtn?.message || 'Purchase failed');
    }
  }

  async checkStatus(server: any) {
    const rtn: any = await this.http.post('/admin/multichat-server/status', { server_id: server.id });
    if (rtn?.status && rtn.server) {
      server.status = rtn.server.status;
      server.ip_address = rtn.server.ip_address;
      server.hostname = rtn.server.hostname;
    }
  }

  async terminateServer(server: any) {
    if (!confirm(`Terminate this server (${server.ip_address || server.uuid})?\n\nAll channels linked to this server will be unlinked.`)) return;
    const rtn: any = await this.http.post('/admin/multichat-server/terminate', { server_id: server.id });
    if (rtn?.status) {
      this.http.notify(rtn.message || 'Server terminated');
      await this.loadServers();
    } else {
      this.http.notify(rtn?.message || 'Failed to terminate');
    }
  }

  getStatusBadge(status: string): string {
    switch (status) {
      case 'active': return 'bg-success';
      case 'provisioning': return 'bg-warning text-dark';
      case 'pending': return 'bg-info text-dark';
      case 'suspended': return 'bg-danger';
      case 'terminated': return 'bg-secondary';
      default: return 'bg-secondary';
    }
  }
}
